import fourColumnData from "../constants/fourColumnData";
import threeColumnData from "../constants/threeColumnData";
import cocSecondTable from "../constants/cocSecondTable";

export const HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
};

export const DATE_TIME_FORMAT_1 = "MM/dd/yyyy HH:mm";
export const DATE_FORMAT_1 = "yyyy-MM-dd";
export const DATE_FORMAT_2 = "MM/dd/yyyy";

export const LANGUAGE = [
  "English",
  "Spanish",
  "Mandarin",
  "Catonese",
  "Arabic",
  "French",
];

// admin group
export const ADMIN = "ADMIN";
export const TESTER = "TESTER";
// water system group
export const PWS = "PWS";
// vendor group
export const OWP = "OWP";
export const SWB = "SWB";
export const GEOSYNTEC = "GEOSYNTEC";
export const BABCOCK = "BABCOCK";
export const DISTRICT_OFFICE = "DISTRICT_OFFICE";

// admin tools name
export const PWS_LOOKUP = "PWS_LOOKUP";
export const REPORTS = "REPORTS";
export const WELLS_CONTACTS = "WELLS_CONTACTS";
export const WELL_LIST = "WELL_LIST";
export const PWS_CONTACTS_DETAILS = "PWS_CONTACTS_DETAILS";
export const SCHEDULE_GOALS = "SCHEDULE_GOALS";
export const SCHEDULE_SAMPLERS = "SCHEDULE_SAMPLERS";
export const WEEKLY_SAMPLE_KIT = "WEEKLY_SAMPLE_KIT";
export const PWS_BY_DISTRICT_OFFICES = "PWS_BY_DISTRICT_OFFICES";
export const VIDEOS = "VIDEOS";
export const IMPORT_KITS = "IMPORT_KITS";
export const IMPORT_RESULTS = "IMPORT_RESULTS";
export const IMPORT_FIELD_DATA = "IMPORT_FIELD_DATA";
export const FIELD_DATA_EDD = "FIELD_DATA_EDD";

// characters to be excluded when user is inputting data in the form
export const EXCLUDED_SPECIAL_CHARACTERS = [
  "@",
  "#",
  "$",
  "%",
  "^",
  "&",
  "*",
  "(",
  ")",
  "_",
  "+",
  "=",
  "{",
  "}",
  "[",
  "]",
  "|",
  "\\",
  ":",
  ";",
  '"',
  "'",
  "<",
  ">",
  ",",
  ".",
  "?",
  "/",
  "~",
  "`",
  "!",
  "©",
  "®",
  "™",
  "€",
  "£",
  "¥",
];

// COC
export const SAMPLE_KITS = [
  "Kit A",
  "Kit B",
  "Kit C",
  "Kit D",
  "Kit E",
  "Kit F",
];
export const FOUR_COLUMN_DATA = fourColumnData;
export const THREE_COLUMN_DATA = threeColumnData;
export const COC_SECOND_TABLE = cocSecondTable;
